export default "__VITE_ASSET__90b1afa4__"